import { useEffect } from 'react'
import useDarkModeStore from '@/hooks/utils/dark-mode'

const LayoutWrapper = ({ children }) => {
    const { initialize } = useDarkModeStore()

    useEffect(() => {
        initialize()
    }, [])

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                document.body.style.filter = 'blur(8px)'
            } else {
                document.body.style.filter = 'none'
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)
        return () => {
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange,
            )
        }
    }, [])

    return <>{children}</>
}

export default LayoutWrapper
